export const MIN_15 = 5 * 60 * 1000;